import { render, staticRenderFns } from "./ModernSuggestionWithAction.vue?vue&type=template&id=3e856aab&scoped=true"
import script from "./ModernSuggestionWithAction.vue?vue&type=script&lang=js"
export * from "./ModernSuggestionWithAction.vue?vue&type=script&lang=js"
import style0 from "./ModernSuggestionWithAction.vue?vue&type=style&index=0&id=3e856aab&prod&lang=scss&scoped=true"
import style1 from "./ModernSuggestionWithAction.vue?vue&type=style&index=1&id=3e856aab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e856aab",
  null
  
)

export default component.exports